import styled from '@emotion/styled';
import { mediaQueries, remCalc, font, focuses } from '../../css';

const StyledSlideName = styled('span')(
    () => ({
        flex: '1 0 0',
        lineHeight: font.size.m,
        fontSize: font.size.m,
        fontWeight: font.weight.medium,
        textTransform: 'capitalize',
        display: 'block',
        [mediaQueries.medium]: {
            lineHeight: font.size.l,
        },
    }),
    ({ theme }) => ({
        color: theme.global.textColor,
    }),
);

const StyledSlideDate = styled('small')(
    () => ({
        flex: '1 0 0',
        lineHeight: font.size.xs,
        fontSize: font.size.xs,

        [mediaQueries.medium]: {
            lineHeight: font.size.s,
            fontSize: remCalc(font.size.s * 0.9),
        },
    }),
    ({ theme }) => ({
        color: theme.global.textColor,
    }),
);

const StyledSlideButton = styled('button')(
    ({ theme }) => ({
        textAlign: 'center',
        cursor: 'pointer',
        padding: remCalc(10, 0, 8),
        width: '100%',

        [mediaQueries.medium]: {
            padding: remCalc(15, 0, 13),
        },
        ...focuses.rgaa(':focus,:hover', {
            borderColor: theme.guide.activeSlideColor,
        }),
    }),
    ({ isCurrent, theme }) =>
        isCurrent && {
            background: theme.guide.activeSlideColor,

            [StyledSlideName]: {
                color: theme.guide.activeSlideTextColor,
                fontWeight: font.weight.bold,
            },
            [StyledSlideDate]: {
                color: theme.guide.activeSlideTextColor,
            },
            ':focus,:hover': {
                borderColor: theme.guide.activeSlideTextColor,
            },
        },
);

export { StyledSlideButton, StyledSlideName, StyledSlideDate };
